import { render, staticRenderFns } from "./BVeeInput.vue?vue&type=template&id=64123eda&"
import script from "./BVeeInput.vue?vue&type=script&lang=js&"
export * from "./BVeeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports